var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("body", [
      _vm._m(0),
      _vm._v(" "),
      _c("main", [
        _c("div", { staticClass: "header" }, [
          _c("div", { staticClass: "header_inner" }, [
            _c("div", { staticClass: "header_logo" }, [
              _c("h1", [
                _c(
                  "a",
                  { attrs: { href: _vm.logoClicklink, target: "_self" } },
                  [_vm._v("Amway")]
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "contents" },
          [
            _vm._m(1),
            _vm._v(" "),
            _c("voucher", {
              attrs: { coupons: this.coupons, aboInfo: this.aboInfo },
              on: { couponIdx: _vm.getCouponTotalCount }
            }),
            _vm._v(" "),
            _c("infotag"),
            _vm._v(" "),
            _c("uselist", {
              attrs: {
                couponsDetails: this.couponsDetails,
                isexpired: this.couponExpired
              },
              on: {
                setcouponRetrieve: _vm.setcouponRetrieve,
                updateListSize: _vm.updateDetailsSize,
                updateListMode: _vm.updateDetailsMode,
                scrollLockWhenPopupOpen: _vm.scrollLockWhenPopupOpen
              }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "skipToContent" } }, [
      _c("a", { attrs: { href: "#contents" } }, [_vm._v("콘텐츠 바로가기 ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "concierce_visual" }, [
      _c("h2", { staticClass: "visual_title" }, [
        _vm._v('"I\'M PROUD OF YOU"')
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "visual_desc" }, [
        _vm._v("Rich와 Jay의 다이아몬드 리더님을 향한 마음을 되새기겠습니다.")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "visual_label" }, [
        _c("img", {
          attrs: {
            src: require("./images/concierce_label.png"),
            alt: "DIAMOND CONCIERGE"
          }
        })
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e5d44cf4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5d44cf4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/concierge/conciergeMain.vue
// module id = null
// module chunks = 